var map = {
	"./arrive.svg": 145,
	"./arrive_left.svg": 146,
	"./arrive_right.svg": 147,
	"./arrive_straight.svg": 148,
	"./close.svg": 149,
	"./continue.svg": 150,
	"./continue_left.svg": 151,
	"./continue_right.svg": 152,
	"./continue_slight_left.svg": 153,
	"./continue_slight_right.svg": 154,
	"./continue_straight.svg": 155,
	"./continue_uturn.svg": 156,
	"./depart.svg": 157,
	"./depart_left.svg": 158,
	"./depart_right.svg": 159,
	"./depart_straight.svg": 160,
	"./end_of_road_left.svg": 161,
	"./end_of_road_right.svg": 162,
	"./flag.svg": 163,
	"./fork.svg": 164,
	"./fork_left.svg": 165,
	"./fork_right.svg": 166,
	"./fork_slight_left.svg": 167,
	"./fork_slight_right.svg": 168,
	"./fork_straight.svg": 169,
	"./invalid.svg": 170,
	"./invalid_left.svg": 171,
	"./invalid_right.svg": 172,
	"./invalid_slight_left.svg": 173,
	"./invalid_slight_right.svg": 174,
	"./invalid_straight.svg": 175,
	"./invalid_uturn.svg": 176,
	"./merge_left.svg": 177,
	"./merge_right.svg": 178,
	"./merge_slight_left.svg": 179,
	"./merge_slight_right.svg": 180,
	"./merge_straight.svg": 181,
	"./new_name_left.svg": 182,
	"./new_name_right.svg": 183,
	"./new_name_sharp_left.svg": 184,
	"./new_name_sharp_right.svg": 185,
	"./new_name_slight_left.svg": 186,
	"./new_name_slight_right.svg": 187,
	"./new_name_straight.svg": 188,
	"./notificaiton_sharp_right.svg": 189,
	"./notification_left.svg": 190,
	"./notification_right.svg": 191,
	"./notification_sharp_left.svg": 192,
	"./notification_slight_left.svg": 193,
	"./notification_slight_right.svg": 194,
	"./notification_straight.svg": 195,
	"./off_ramp_left.svg": 196,
	"./off_ramp_right.svg": 197,
	"./off_ramp_slight_left.svg": 198,
	"./off_ramp_slight_right.svg": 199,
	"./on_ramp_left.svg": 200,
	"./on_ramp_right.svg": 201,
	"./on_ramp_sharp_left.svg": 202,
	"./on_ramp_sharp_right.svg": 203,
	"./on_ramp_slight_left.svg": 204,
	"./on_ramp_slight_right.svg": 205,
	"./on_ramp_straight.svg": 206,
	"./rotary.svg": 207,
	"./rotary_left.svg": 208,
	"./rotary_right.svg": 209,
	"./rotary_sharp_left.svg": 210,
	"./rotary_sharp_right.svg": 211,
	"./rotary_slight_left.svg": 212,
	"./rotary_slight_right.svg": 213,
	"./rotary_straight.svg": 214,
	"./roundabout.svg": 215,
	"./roundabout_left.svg": 216,
	"./roundabout_right.svg": 217,
	"./roundabout_sharp_left.svg": 218,
	"./roundabout_sharp_right.svg": 219,
	"./roundabout_slight_left.svg": 220,
	"./roundabout_slight_right.svg": 221,
	"./roundabout_straight.svg": 222,
	"./roundabout_turn_left.svg": 223,
	"./turn_left.svg": 224,
	"./turn_right.svg": 225,
	"./turn_sharp_left.svg": 226,
	"./turn_sharp_right.svg": 227,
	"./turn_slight_left.svg": 228,
	"./turn_slight_right.svg": 229,
	"./turn_straight.svg": 230,
	"./updown.svg": 231,
	"./uturn.svg": 232
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20;


//////////////////
// WEBPACK FOOTER
// ./src/assets/diving_icons ^\.\/.*$
// module id = 20
// module chunks = 0